import useLocalStorage from "@rehooks/local-storage";
import { useEffect, useState } from "react";

// Need the timeout to make hydration match with server
export default function useNavCollapse(): [boolean, (newValue: boolean) => void] {
  const [collapse, setCollapse] = useLocalStorage<boolean>("navCollapse", false);
  const [ready, isReady] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      isReady(true);
    });
  }, []);

  if (!ready) {
    return [false, setCollapse];
  }

  return [collapse, setCollapse];
}
